/**
* Navbar JS
* -----------------------------------------------------------------------------
*
* Keeps --navbarHeight and --hours-height in sync with what the navbar
* actually renders, so --totalNavbarHeight and --topOffset stay correct.
*/
( function( app ) {
  const COMPONENT = {
    className: 'navbar',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      window.debounce = window.debounce || require( 'lodash/debounce' );

      const publishHeights = function() {
        const $row = $( '.navbar-row' );
        const $hours = $( '.navbar-hours' );

        if ( $row.length ) {
          $( ':root' ).css( '--navbarHeight', `${Math.ceil( $row.outerHeight() )}px` );
        }

        const hoursHeight = $hours.length && $hours.is( ':visible' ) ? Math.ceil( $hours.outerHeight() ) : 0;
        $( ':root' ).css( '--hours-height', `${hoursHeight}px` );
      };

      publishHeights();
      $( window ).on( 'load', publishHeights );
      $( window ).on( 'resize', debounce( publishHeights, 100 ) );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'navbar', COMPONENT );
} )( app );
